import type React from 'react';
import IconCorrect32 from './-assets/icon_correct_32.svg';
import IconCorrect64 from './-assets/icon_correct_64.svg';
import IconFailed32 from './-assets/icon_failed_32.svg';
import IconFailed64 from './-assets/icon_failed_64.svg';
import styles from './index.module.scss';

export type EvaluationMarkProps = {
  /**
   * 評価結果
   * - true: ○（合格）
   * - false: ×（不合格）
   * - null/undefined: -（未評価）
   */
  isPassed: boolean | null | undefined;
  /**
   * マークのサイズ（px）
   * - 64: EvaluationSummary用
   * - 32: EvaluationDetails用
   * @default 64
   */
  size?: 32 | 64;
  className?: string;
};

const SIZE_CONFIG = {
  32: {
    correctIcon: IconCorrect32,
    failedIcon: IconFailed32,
    dashTextClass: styles.dashText32,
  },
  64: {
    correctIcon: IconCorrect64,
    failedIcon: IconFailed64,
    dashTextClass: styles.dashText64,
  },
} as const;

export const EvaluationMark: React.FC<EvaluationMarkProps> = ({
  isPassed,
  size = 64,
  className,
}) => {
  const config = SIZE_CONFIG[size];

  if (isPassed === true) {
    return <img src={config.correctIcon} alt="合格" className={className} />;
  }

  if (isPassed === false) {
    return <img src={config.failedIcon} alt="不合格" className={className} />;
  }

  return (
    <span className={`${config.dashTextClass} ${className || ''}`}>-</span>
  );
};
